
































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';
import receiptServices from '@/services/receipt-services';
import utility from '@/utility/utility';

@Component
export default class ListPayService extends Vue {
    @Prop({default: {}})
    private listReceipt: any;
    private isCheckAll = false;
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    get configuration() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].configuration;
    }

    get shippingTypes()  {
        if (this.configuration && this.configuration.ShippingTypes) {
            return JSON.parse(this.configuration.ShippingTypes);
        }
        return [];
    }

    private async viewDetail(receipt: any) {
        let currentPackages = [];
        const result = await receiptServices.getBillOfLading([{
                    column: 'ExportReceiptID',
                    value: receipt.id,
                    condition: 'equal'
                }]);
        if (result && result.data && result.data.status === 200) {
            currentPackages = result.data.data;
        }
        utility.print_export_receipt_order(receipt, currentPackages);
    }

    private getShippingType(value: number) {
        const p = this.shippingTypes.find(x => x.value === value);
        return p ? p.name : '';
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }

    private async onCheckAllOrder() {
        this.$emit(this.eventEmit.eventCheckALl, this.isCheckAll);
    }
}
